/**
 * @file useIdleLogout.js
 * @feature Auth
 * @description Tracks user activity (mousemove + keydown) and triggers
 * an MSAL logoutRedirect after a configurable idle period.
 *
 * FDD rationale: idle-logout is a standalone security behaviour with
 * no coupling to profile fetching or token refresh.
 */

import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { IDLE_LOGOUT_MS } from '../../config/Auth.config';

export const useIdleLogout = () => {
  const { instance } = useMsal();

  useEffect(() => {
    let timer;

    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => instance.logoutRedirect(), IDLE_LOGOUT_MS);
    };

    window.addEventListener('mousemove', reset);
    window.addEventListener('keydown', reset);
    reset(); // kick off the initial timer

    return () => {
      clearTimeout(timer);
      window.removeEventListener('mousemove', reset);
      window.removeEventListener('keydown', reset);
    };
  }, [instance]);
};